/* eslint-disable react/button-has-type */
import React, { useState } from 'react';
import { AiOutlineLoading } from 'react-icons/ai';
import { ButtonProps, ButtonVariant } from './types';

const variantClassNames: Record<ButtonVariant, string> = {
  primary:
    'text-white bg-indigo-600 hover:bg-indigo-500 font-medium rounded-md py-2 px-6 disabled:opacity-50 disabled:cursor-not-allowed',
  secondary:
    'text-white bg-indigo-600 hover:bg-indigo-500 font-medium rounded-md py-2 px-6',
  cancel: 'text-indigo-300 font-bold px-6 text-sm focus:outline-none',
  anchor:
    'text-indigo-600 background-transparent outline-none focus:outline-none',
};

const Button: React.FC<ButtonProps> = ({
  onClick,
  children,
  className = '',
  disabled,
  type = 'button',
  variant = 'primary',
  isLoading = false,
}) => {
  return (
    <button
      onClick={onClick}
      type={type}
      className={`${variantClassNames[variant]} ${className}`}
      disabled={disabled || isLoading}
    >
      <span className="flex items-center space-x-2">
        <span>{children}</span>
        {isLoading ? <AiOutlineLoading className="animate-spin" /> : null}
      </span>
    </button>
  );
};

export default Button;
